/* eslint-disable react/prop-types */
import React from "react";
import { TableWrap } from "./style";

export const TableLoading = (props) => {
  const { id, columns, actions, checkBoxVal, style } = props;
  return (
    <TableWrap>
      <div id={id} className="tweet" style={style}>
        <div className="skeleton">
          <div className="tweet-content">
            <div className="tweet-header">
              <div className="skeleton-line heading">
                <div className="heading-checkbox">
                  {checkBoxVal === undefined ? (
                    <div className="skeleton-checkbox" />
                  ) : checkBoxVal === false ? null : (
                    <div className="skeleton-checkbox" />
                  )}
                  {columns.map((index) => (
                    <div key={index} className="skeleton-column" />
                  ))}
                </div>
              </div>
            </div>
            <div style={{ height: "calc(100vh - 300px)" }}>
              {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(
                (d, i) => (
                  <div key={i} className="skeleton-img">
                    <div className="tweet-footer" style={{ float: "left" }}>
                      {checkBoxVal === undefined ? (
                        <div className="skeleton-button rounded" />
                      ) : checkBoxVal === false ? null : (
                        <div className="skeleton-button rounded" />
                      )}
                    </div>
                    <div
                      className="tweet-footer"
                      style={{ float: "left", width: "14%" }}
                    >
                      {columns.map((index) => (
                        <div key={index} className="text-column" />
                      ))}
                    </div>
                    <div className="tweet-footer" style={{ float: "right" }}>
                      {actions !== undefined ? (
                        actions.map((index) => (
                          <div
                            key={index}
                            className="skeleton-button rounded"
                          />
                        ))
                      ) : (
                        <>
                          <div className="skeleton-button rounded" />
                          <div className="skeleton-button rounded" />
                        </>
                      )}
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </TableWrap>
  );
};
